function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 19.16V.84a10 10 0 00-8 0v18.32a10 10 0 008 0z",
  fill: "#f3cb3a"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 .84v18.32A10 10 0 0014 .84z",
  fill: "#c70b2c"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 19.16V.84a10 10 0 000 18.32z",
  fill: "#112977"
});

function SvgRo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjNjYjNhO30uY2xzLTJ7ZmlsbDojYzcwYjJjO30uY2xzLTN7ZmlsbDojMTEyOTc3O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNCwxOS4xNlYuODRoMGExMCwxMCwwLDAsMC04LDBINlYxOS4xNkg2YTEwLDEwLDAsMCwwLDgsMFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xNCwuODRWMTkuMTZBMTAsMTAsMCwwLDAsMTQsLjg0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTYsMTkuMTZWLjg0QTEwLDEwLDAsMCwwLDYsMTkuMTZaIi8+PC9zdmc+";
export { SvgRo as ReactComponent };